import { render } from "./quickLinks.vue?vue&type=template&id=73b154c8"
import script from "./quickLinks.vue?vue&type=script&lang=js"
export * from "./quickLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__